import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePostPutawayListMutation } from "../../../../store/api/putawayapi";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ExportCSV from '../../../../Core/Export/ExportCSV';
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";

const MainContent = () => {
    const navigate = useNavigate();
    const { screenHeight, screenScaling, pageSize} = useScreenHeight();
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [putawayData, setPutawaydata] = useState({ putaway_list: [], total_no_of_records: 0 });
    const [PutawayDataApi] = usePostPutawayListMutation();
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [deleteDoc] = useDeleteDocMutation();

    const filtersConfig = [
        { name: 'siNo', label: 'S. No.', width: '5%', type: 'text' },
        { name: 'putaway_no', label: 'Putaway Id', width: '7%', type: 'text' },
        { name: 'grn_no', label: 'GRN No', width: '10.7%', type: 'text' },
        { name: 'purchase_order_no', label: 'Purchase Order', width: '11.7%', type: 'text' },
        { name: 'noOfLines', label: 'No. of Lines', type: 'number', width: '8.7%' },
        { name: 'totalQuantity', label: 'Total Quantity', type: 'number', width: '8.7%' },
        { name: 'vendor', label: 'Vendor', width: '10.7%', type: 'text' },
        { name: 'date', label: 'Date', type: 'date', width: '10.7%' },
        {
            name: 'status',
            label: 'Status',
            width: '10.7%',
            type: 'select',
            options: [
                { value: 'pending', label: 'Pending' },
                { value: 'completed', label: 'Completed' },
                { value: 'cancelled', label: 'Cancelled' },
                { value: 'Submitted', label: 'Submitted' },
                { value: 'Draft', label: 'Draft' },
                { value: 'Partially Receipt', label: 'Partially Receipt' },
                { value: 'To Receive and Bill', label: 'To Receive and Bill' },
                { value: 'Completely Receipt', label: 'Completely Receipt' }
            ]
        },
        { name: 'company', label: 'Company', width: '10.7%', type: 'text' },
        { name: 'required_by', label: 'Required By', width: '10.7%', type: 'date' },
        { name: 'net_total', label: 'Net Total', width: '8.7%', type: 'number' },
        { name: 'total', label: 'Total', width: '8.7%', type: 'number' },
        { name: 'grand_total', label: 'Grand Total', width: '8.7%', type: 'number' },
    ];


    const [columnsConfig, setColumnsConfig] = useState(() => [
        {
            header: "S. No.",
            name: "S. No.",
            accessor: "siNo",
            width: '2%',
            cellRenderer: (row)=> row.siNo,
            sortable: false,
            visible: true
        },
        {
            header: "Putaway ID",
            name: "Putaway ID",
            accessor: "putaway_no",
            width: '7.7%',
            sortable: true,
            visible: true
        },
        {
            header: "GRN No.",
            name: "GRN No.",
            accessor: "grn_no",
            sortable: true,
            visible: true
        },
        {
            header: "PO No.",
            name: "PO No.",
            accessor: "purchase_order_no",
            sortable: true,
            visible: true
        },
        {
            header: "Date",
            name: "Date",
            accessor: "doc_date",
            sortable: true,
            visible: true,
            sortFn: (a, b) => new Date(a.doc_date) - new Date(b.doc_date)
        },
        {
            header: "Created By",
            name: "Created By",
            accessor: "created_by",
            sortable: false,
            visible: false
        },
        {
            header: "Assigned To",
            name: "Assigned To",
            accessor: "assigned_to",
            sortable: false,
            visible: false,
            cellRenderer: (row) => row.assigned_to?.join(", ") || "-"
        },
        {
            header: "No. of Lines",
            name: "No. of Lines",
            accessor: "no_of_lines",
            sortable: false,
            visible: false
        },
        {
            header: "Total Received Qty",
            name: "Total Received Qty",
            accessor: "total_received_qty",
            sortable: false,
            visible: false
        },
        {
            header: "Total Putaway Qty",
            name: "Total Putaway Qty",
            accessor: "total_putaway_qty",
            sortable: false,
            visible: false
        },
        {
            header: "Grand Total",
            name: "Grand Total",
            accessor: "grand_total",
            sortable: true,
            visible: true,
            cellRenderer: (row) => row.grand_total?.toLocaleString()
        },
        {
            header: "Supplier Name",
            name: "Supplier Name",
            accessor: "supplier_name",
            sortable: false,
            visible: true
        },
        {
            header: "Supplier Address",
            name: "Supplier Address",
            accessor: "supplier_address",
            sortable: false,
            visible: false
        },
        {
            header: "Supplier Contact",
            name: "Supplier Contact",
            accessor: "supplier_contact",
            sortable: false,
            visible: false
        },
        {
            header: "Supplier Email",
            name: "Supplier Email",
            accessor: "supplier_email",
            sortable: false,
            visible: false
        },
        {
            header: "Status",
            name: "Status",
            accessor: "status",
            sortable: true,
            visible: true,
            cellRenderer: (row) => {
                const status = row.status;
                let color;

                switch (status) {
                    case 'Submitted':
                        color = '#0E7490';
                        break;
                    case 'Draft':
                        color = '#6366F1';
                        break;
                    case 'Completed':
                        color = '#65A30D';
                        break;
                    case 'Cancelled':
                        color = '#EF4444';
                        break;
                    case 'Pending':
                        color = '#F97316';
                        break;
                    default:
                        color = '#000000';
                }

                return (
                    <span
                        style={{
                            backgroundColor: `${color}1A`,
                            color,
                            padding: '4px 10px',
                            borderRadius: '9999px',
                            fontSize: '12px',
                            fontWeight: 500,
                            display: 'inline-block',
                            textTransform: 'capitalize',
                        }}
                    >
                        {status}
                    </span>
                );
            }
        },
        {
            header: "Action",
            name: "Action",
            width: '10%',
            accessor: "action",
            sortable: false,
            visible: true,
            cellRenderer: (row) => (
                <ActionButtonDropdown
                    status={row.status}
                    id={row.putaway_no}
                    onView={() => handleView(row.putaway_no, row.status)}
                    onEdit={() => handleEdit(row.putaway_no, row.status)}
                    onDelete={() => handleDelete(row.putaway_no)}
                />
            )
        },
    ]);

    // Handle column configuration changes
    const handleSaveColumns = (selectedKeys, allFields) => {
        const updatedColumns = columnsConfig.map(column => {
            return {
                ...column,
                visible: selectedKeys.includes(column.accessor)
            };
        });
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible === true),
        [columnsConfig]
    );

    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible === true)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            }))
            .filter(col => col.fieldname),
        [columnsConfig]
    );

    const handleView = (putaway_no, status) => {
        try {
            navigate(`/inbound/putaway/view-putaway`, { state: { putaway_no, status } });
        } catch (err) {
            console.error("View failed:", err);
        }
    };

    const handleEdit = async (putaway_no, status) => {
        try {
            if (status === "Submitted") {
                navigate(`/inbound/putaway/view-putaway`, { state: { putaway_no, status } });
            } else {
                navigate(`/inbound/putaway/edit-putaway`, { state: { putaway_no, status } });
            }
        } catch (err) {
            console.error("Edit failed:", err);
        }
    };

    const [delPopupVisible, setDelPopupVisible] = useState(false);
    const [delSelectedId, setDelSelectedId] = useState(null);
    const [delmessage, setDelmessage] = useState();
    const [alreadySubmitData, setAlreadySubmitData] = useState(false)
    const [delDone, setDelDone] = useState(false)

    const handleDelete = (id) => {
        setDelSelectedId(id);
        setDelPopupVisible(true)
        setAlreadySubmitData(false)
        setDelmessage("Are you sure you want to Delete this Put away?");
    };

    const delHandleCancel = () => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
    }

    const delHandleConfirm = async () => {
        
        try {
            await deleteDoc({ doctype: "Stock Entry", name: delSelectedId }).unwrap()
            setDelmessage(`Put Away ${delSelectedId} deleted successfully!`)
            setDelDone(true)
            setTimeout(() => {
                setDelPopupVisible(false);
                setDelDone(false)
                getData();
            }, 1000);
        } catch (err) {
            console.error("Deletion Failed:", err)

            let errorMessage = "Failed to delete the Put away!";

            //If the server is sending the error message , we will extract it.
            if (err?.data?._server_messages) {
                try {
                    const messageArr = JSON.parse(err.data._server_messages)
                    if (messageArr && messageArr.length > 0) {
                        //parse inner json object
                        const messageObj = JSON.parse(messageArr[0])
                        if (messageObj?.message) {
                            //extract the exact message we want
                            const fullMessage = messageObj.message
                            errorMessage = fullMessage.split('You must')[0].trim();
                            //remove html in the message
                            errorMessage = errorMessage.replace(/<[^>]+>/g, '');

                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelPopupVisible(true)
            setDelmessage(errorMessage)
            setAlreadySubmitData(true);
        } finally {
            // setTimeout(() => {
            //     setDelPopupVisible(false);
            //     setDelSelectedId(null);
            // }, 2000);
        }
    };
    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);

    const actionButtons = [
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),
        },
        {
      className: "custom-btn-00989 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "FiPlus",
      iconSize: 12,
      children: "Create Put Away",
      to: "/inbound/putaway/create-putaway",
    }
    ];

    const getData = async () => {
			setLoading(true);
			try {
				const filteredSearchInput = Object.entries(filters).reduce(
					(acc, [key, value]) => {
						if (value !== "" && value !== undefined && value !== null) {
							acc[key] = value;
						}
						return acc;
					},
					{}
				);
				const siNoFilter = filteredSearchInput.siNo;
				const isSiNoFilterActive =
					siNoFilter !== undefined && siNoFilter !== "";
				// STEP 3: If filtering by siNo, jump to that page
				const targetPage = isSiNoFilterActive
					? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
					: currentPage;
				const payload = {
					start: pageSize * (targetPage - 1),
					page_length: pageSize,
					...(Object.keys(filteredSearchInput).length > 0 && {
						search_input: {
							putaway_no: filteredSearchInput.putaway_no || "",
							grn_no: filteredSearchInput.grn_no || "",
							purchase_order_no: filteredSearchInput.purchase_order_no || "",
							status: filteredSearchInput.status || "",
							date: filteredSearchInput.date || "",
							vendor: filteredSearchInput.vendor || "",
							noOfLines: filteredSearchInput.noOfLines || "",
							totalQuantity: filteredSearchInput.totalQuantity || "",
						},
					}),
				};

				const response = await PutawayDataApi(payload);
				// console.log("Res PutAWAY", response);

				const rawData = response.data.data.putaway_list;
				// STEP 4: Assign global serial numbers
				const numberedData = rawData.map((item, index) => ({
					...item,
					siNo: index + 1 + pageSize * (targetPage - 1),
				}));

				// STEP 5: If siNo is used, filter client-side
				const finalData = isSiNoFilterActive
					? numberedData.filter(
							(item) => item.siNo === parseInt(siNoFilter, 10)
					  )
					: numberedData;
				setPutawaydata({
					putaway_list: finalData,
					total_no_of_records: response.data.data.total_no_of_records || 0,
				});
				// console.log("Res PutAWAY",putawayData)
				// Optional: update currentPage to reflect jump
				if (isSiNoFilterActive) setCurrentPage(targetPage);
			} catch (error) {
				console.error("Error fetching putaway data:", error);
			} finally {
				setLoading(false);
			}
		};

    const handleFilterChange = (newFilters) => {
        setCurrentPage(1);
        setFilters(newFilters);
    };

    useEffect(() => {
		if (pageSize >  0) getData();
	}, [currentPage, filters, pageSize, screenHeight, screenScaling]);
    const accessors = columnsConfig
			.filter(
				(column) => column.accessor !== "siNo" && column.accessor !== "action"
			)
			.map((column) => column.accessor);
    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: '1' }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Inbound" },
                    { label: "Put Away List", style: { color: '#391F84' } }
                ]}
                actionButtons={actionButtons}
            >
                {showFilters && (
                    <ListFilters
                        filtersConfig={filtersConfig}
                        onFilterChange={handleFilterChange}
                        currentFilters={filters}
                        setShowFilters={setShowFilters}
                    />
                )}

                {showColumnConfig && (
                    <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="Stock Entry"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo", "status", "action","supplier_name","grn_no","putaway_no","doc_date","grand_total"]}
                    />
                )}

                <Table
                    columns={visibleColumns}
                    data={putawayData.putaway_list}
                    loading={loading}
                />

                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={putawayData.total_no_of_records}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
                {delPopupVisible &&
                    <DelConfirmPopup
                        alredysubmitdata={alreadySubmitData}
                        delSelectedId={delSelectedId}
                        visible={delPopupVisible}
                        message={delmessage}
                        onConfirm={delHandleConfirm}
                        onCancel={delHandleCancel}
                        delDone={delDone}
                    />}
                {showExportPopup && (
                    <ExportCSV
                        doctype="Stock Entry"
                        fieldsData={accessors}
                        onClose={() => setShowExportPopup(false)}
                    />
                )}
            </ListLayout>
        </div>
    );
};

export default MainContent;